module.exports = __webpack_public_path__ + "static/media/VIDEO-COUNT-1.ab975cb7.png";